import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import API_URL from "./config";

export default function FreeAgencyRecap({ recap, onDismiss }) {
  const navigate = useNavigate();
  const [advancing, setAdvancing] = useState(false);

  const handleAdvanceToDashboard = async () => {
    setAdvancing(true);
    try {
      // Navigate back to dashboard to finalize
      navigate("/dashboard");
    } catch (e) {
      // Error advancing
      // Fallback to navigation anyway
      navigate("/dashboard");
    }
  };

  if (!recap) {
    return null;
  }

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "rgba(0,0,0,0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000
      }}
    >
      <div
        style={{
          background: "white",
          borderRadius: "12px",
          maxWidth: "900px",
          width: "90%",
          maxHeight: "90vh",
          overflow: "auto",
          boxShadow: "0 20px 60px rgba(0,0,0,0.3)"
        }}
      >
        {/* Header */}
        <div
          style={{
            padding: "2rem",
            background: "#111",
            color: "white",
            borderBottom: "1px solid #e5e7eb"
          }}
        >
          <h1 style={{ margin: 0, fontSize: "2rem", fontWeight: "700" }}>
            📊 Offseason Complete!
          </h1>
          <p style={{ margin: "0.5rem 0 0 0", color: "#ccc" }}>
            Free Agency Results & Team Signings
          </p>
        </div>

        {/* Summary Stats */}
        <div
          style={{
            padding: "2rem",
            background: "#f9fafb",
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
            gap: "1.5rem",
            borderBottom: "1px solid #e5e7eb"
          }}
        >
          <div>
            <div style={{ color: "#374151", fontSize: "0.85rem", marginBottom: "0.5rem", fontWeight: "500" }}>
              Your Signings
            </div>
            <div style={{ fontSize: "2rem", fontWeight: "700", color: "#10b981" }}>
              {recap.userSigningCount || 0}
            </div>
          </div>
          <div>
            <div style={{ color: "#374151", fontSize: "0.85rem", marginBottom: "0.5rem", fontWeight: "500" }}>
              AI Team Signings
            </div>
            <div style={{ fontSize: "2rem", fontWeight: "700", color: "#3b82f6" }}>
              {recap.aiSigningCount || 0}
            </div>
          </div>
          <div>
            <div style={{ color: "#374151", fontSize: "0.85rem", marginBottom: "0.5rem", fontWeight: "500" }}>
              Total Signed
            </div>
            <div style={{ fontSize: "2rem", fontWeight: "700", color: "#8b5cf6" }}>
              {recap.totalSigned || 0}
            </div>
          </div>
        </div>

        {/* All Signings Table */}
        <div style={{ padding: "2rem" }}>
          <h2 style={{ margin: "0 0 1.5rem 0", fontSize: "1.25rem", fontWeight: "600", color: "#111" }}>
            All Signings (Sorted by Overall)
          </h2>

          <div
            style={{
              overflowX: "auto"
            }}
          >
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse"
              }}
            >
              <thead>
                <tr style={{ background: "#f3f4f6", borderBottom: "2px solid #e5e7eb" }}>
                  <th style={{ padding: "0.75rem", textAlign: "left", fontWeight: "600", color: "#111" }}>
                    Player
                  </th>
                  <th style={{ padding: "0.75rem", textAlign: "left", fontWeight: "600", color: "#111" }}>
                    Team
                  </th>
                  <th style={{ padding: "0.75rem", textAlign: "center", fontWeight: "600", color: "#111" }}>
                    OVR
                  </th>
                  <th style={{ padding: "0.75rem", textAlign: "center", fontWeight: "600", color: "#111" }}>
                    Pos
                  </th>
                  <th style={{ padding: "0.75rem", textAlign: "right", fontWeight: "600", color: "#111" }}>
                    Salary / Years
                  </th>
                </tr>
              </thead>
              <tbody>
                {recap.allSignings && recap.allSignings.length > 0 ? (
                  recap.allSignings.map((signing, idx) => (
                    <tr
                      key={idx}
                      style={{
                        borderBottom: "1px solid #e5e7eb",
                        background: idx % 2 === 0 ? "white" : "#f9fafb"
                      }}
                    >
                      <td style={{ padding: "1rem 0.75rem", fontWeight: "600", color: "#111" }}>
                        {signing.playerName}
                      </td>
                      <td style={{ padding: "1rem 0.75rem", color: "#374151" }}>
                        {signing.teamName}
                      </td>
                      <td
                        style={{
                          padding: "1rem 0.75rem",
                          textAlign: "center",
                          fontWeight: "700",
                          color:
                            signing.overall >= 80
                              ? "#dc2626"
                              : signing.overall >= 70
                              ? "#f59e0b"
                              : "#6b7280"
                        }}
                      >
                        {signing.overall}
                      </td>
                      <td
                        style={{
                          padding: "1rem 0.75rem",
                          textAlign: "center",
                          color: "#374151"
                        }}
                      >
                        {signing.position}
                      </td>
                      <td
                        style={{
                          padding: "1rem 0.75rem",
                          textAlign: "right",
                          fontWeight: "600",
                          color: "#3b82f6"
                        }}
                      >
                        ${signing.salary}M / {signing.contractYears}yr
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="5"
                      style={{ padding: "2rem", textAlign: "center", color: "#6b7280" }}
                    >
                      No signings recorded
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* Footer with Button */}
        <div
          style={{
            padding: "2rem",
            background: "#f9fafb",
            borderTop: "1px solid #e5e7eb",
            display: "flex",
            justifyContent: "flex-end",
            gap: "1rem"
          }}
        >
          <button
            onClick={handleAdvanceToDashboard}
            disabled={advancing}
            style={{
              padding: "0.875rem 2rem",
              background: "#10b981",
              color: "white",
              border: "none",
              borderRadius: "6px",
              fontSize: "1rem",
              fontWeight: "600",
              cursor: advancing ? "not-allowed" : "pointer",
              opacity: advancing ? 0.7 : 1,
              transition: "all 0.2s"
            }}
          >
            {advancing ? "Advancing..." : "Advance to Regular Season"}
          </button>
        </div>
      </div>
    </div>
  );
}
